import noiseMonitoringIcon from '@/assets/illustrations/noise monitoring.svg'
import dustAirQualityIcon from '@/assets/illustrations/dust and air quality.svg'
import fuelVisibilityIcon from '@/assets/illustrations/fuel visability.svg'
import proactiveAlertsIcon from '@/assets/illustrations/procactive alerts.svg'
import type { IndustryPageContent } from './types'

// Copy: content/unimo-industry-page-copy.md, "CONSTRUCTION" — signed off 28 Aug 2026.
// Stats/citations: content/unimo-industry-stats.md v7 (final) — same date.
// Hero headline is the only thing carried over from the old live page at
// src/features/industries/ConstructionPage.tsx — nothing else from it.
export const constructionContent: IndustryPageContent = {
    key: 'construction',
    hero: {
        headlineLine1: 'Good Neighbour Compliance.',
        headlineLine2: 'Automated.',
    },
    statBand: {
        header: 'What construction teams are up against.',
        stats: [
            {
                figure: '14',
                unit: '%',
                body: "of the UK's fine particle pollution comes off construction sites. Some of it comes off yours.",
                citation: 1,
            },
            {
                figure: '7',
                unit: '×',
                body: 'more Section 61 noise consents in London than twenty years ago. Your neighbours are paying attention.',
                citation: 2,
            },
            {
                figure: '21',
                unit: '%',
                body: 'of project value is lost to avoidable errors. Nobody budgets for that.',
                citation: 3,
            },
        ],
    },
    usps: [
        {
            title: 'Noise monitoring',
            body: 'Council-grade dB sensors across defined zones. Configurable alerts aligned to Section 61 limits. Evidence packs ready for any complaint.',
            icon: noiseMonitoringIcon,
        },
        {
            title: 'Dust and air quality',
            body: 'PM2.5, PM10 and TVOC tracking. Know when suppression measures are needed before breaches occur.',
            icon: dustAirQualityIcon,
        },
        {
            title: 'Generator fuel visibility',
            body: 'Real-time load and runtime monitoring. Identify over-specification and excessive idling. Cut fuel costs and prove Scope 1 emissions.',
            icon: fuelVisibilityIcon,
        },
        {
            title: 'Proactive alerts',
            body: 'Know before thresholds are breached. SMS and email alerts give site managers time to act, not react.',
            icon: proactiveAlertsIcon,
        },
    ],
    closingCta: {
        headline: 'Ready to prove your compliance?',
    },
    references: [
        {
            id: 1,
            text: "National Atmospheric Emissions Inventory, cited in 'Emissions from the Construction Sector in the United Kingdom', Emission Control Science and Technology, 2023.",
            italicPhrase: 'Emission Control Science and Technology',
            url: 'https://link.springer.com/article/10.1007/s40825-023-00237-w',
            linkLabel: 'link.springer.com',
        },
        {
            id: 2,
            text: 'Chartered Institute of Environmental Health, Noise Complaint Data Briefing 2026, Table 5. London: CIEH, 2026.',
            italicPhrase: 'Noise Complaint Data Briefing 2026',
            url: 'https://www.cieh.org/noise-data-2026',
            linkLabel: 'cieh.org',
        },
        {
            id: 3,
            text: 'Get It Right Initiative, research on the cost of avoidable error in UK construction, 2016.',
            url: 'https://getitright.uk.com/reports/call-to-action',
            linkLabel: 'getitright.uk.com',
        },
    ],
}

export default constructionContent
